import { SPEC_COURSE_LESSON_VIEW_TABS } from 'common.components/spec-course-lesson-view/typings';
import { SPEC_COURSE_LESSON_STATUS } from 'common.components/spec-course/typings';

export const getTabToRedirect = (status: SPEC_COURSE_LESSON_STATUS) => {
    switch (status) {
        case SPEC_COURSE_LESSON_STATUS.NOT_STARTED:
        case SPEC_COURSE_LESSON_STATUS.IN_PROGRESS:
        case SPEC_COURSE_LESSON_STATUS.WAITING_FOR_RESULTS:
            return SPEC_COURSE_LESSON_VIEW_TABS.RULES;
        case SPEC_COURSE_LESSON_STATUS.FINISHED:
            return SPEC_COURSE_LESSON_VIEW_TABS.RESULTS;
        default:
            return SPEC_COURSE_LESSON_VIEW_TABS.RULES;
    }
};
